module.exports = __webpack_public_path__ + "img/11.f4a29756.jpg";